export const mapSignupPayload = (formData) => ({
  firstName: formData.firstName,
  lastName: formData.lastName,
  birthdate: formData.dateOfBirth?.format?.("YYYY-MM-DD") || formData.dateOfBirth,
  gender: formData.gender,
  email: formData.email,
  phone: formData.phoneNumber,
  password: formData.password,
  confirmPassword: formData.confirmPassword,
  acceptPrivacyPolicy: Boolean(formData.acceptTerms),
  role: "patient",
  ...(formData.referralToken ? { referralToken: formData.referralToken } : {}),
});

export const sanitizePatientRequestValues = (payload = {}) => {
  const allowedFields = [
    "firstName",
    "lastName",
    "birthdate",
    "gender",
    "email",
    "phone",
    "password",
    "confirmPassword",
    "acceptPrivacyPolicy",
    "referralToken",
  ];

  return Object.fromEntries(
    allowedFields
      .filter((field) => payload[field] !== undefined)
      .map((field) => [field, payload[field]])
  );
};
